import script from "./PasswordStrengthField.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordStrengthField.vue?vue&type=script&setup=true&lang=js"

import "./PasswordStrengthField.vue?vue&type=style&index=0&id=20cdae72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20cdae72"]])

export default __exports__